import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "https://static.readdy.ai/image/f9f32838a9120faa908a5852ba765d83/f8910ea58b264f83bfa3194cce1f37cf.png";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Episodes", path: "/episodes" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-cream/95 backdrop-blur-md shadow-sm border-b border-amber-100"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 flex-shrink-0">
          <img
            src={LOGO_URL}
            alt="The Humble Machine"
            className="h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`font-sans text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  active
                    ? "text-amber-700"
                    : scrolled || !isHome
                    ? "text-stone-700 hover:text-amber-700"
                    : "text-amber-50 hover:text-amber-300"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="#subscribe"
            className={`font-sans text-sm font-bold px-5 py-2.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap active:scale-95 ${
              scrolled || !isHome
                ? "bg-amber-500 hover:bg-amber-400 text-amber-950"
                : "bg-amber-500/90 hover:bg-amber-400 text-amber-950"
            }`}
          >
            Listen Now
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <i
            className={`text-2xl ${scrolled || !isHome ? "text-amber-800" : "text-amber-50"} ${
              menuOpen ? "ri-close-line" : "ri-menu-line"
            }`}
          />
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-cream/98 backdrop-blur-md border-t border-amber-100 px-6 pb-6 pt-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="font-sans text-base font-medium text-stone-700 hover:text-amber-700 transition-colors cursor-pointer whitespace-nowrap py-2"
            >
              {link.label}
            </Link>
          ))}
          <a
            href="#subscribe"
            className="font-sans text-sm font-bold px-5 py-2.5 rounded-full bg-amber-500 hover:bg-amber-400 text-amber-950 text-center whitespace-nowrap active:scale-95 transition-all duration-200"
          >
            Listen Now
          </a>
        </div>
      )}
    </header>
  );
}
